import * as React from "react";
const SvgFiRrSushi = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sushi_svg__a)">
      <path
        fill="#062147"
        d="M4.5 11c.067 1.293 7.938 1.291 8 0-.067-1.293-7.938-1.29-8 0m7-6c.067 1.293 7.938 1.291 8 0-.067-1.293-7.938-1.29-8 0M24 5v8c0 2.492-2.948 4.516-7 4.922C18.238 25.678.277 25.9 0 19v-8c0-2.5 2.974-4.514 7-4.92C5.76-1.68 23.723-1.9 24 5M9 5c.022.39.186.757.461 1.032 2.108.062 4.15.746 5.868 1.968 3.742.088 6.726-1.558 6.671-3-.423-3.943-12.581-3.94-13 0m-7 6c.424 3.944 12.581 3.94 13 0-.424-3.944-12.581-3.939-13 0m13 8v-4.749c-2.963 2.292-10.037 2.292-13 0v4.75c.422 3.942 12.582 3.938 13 0m7-6V8.251a10.87 10.87 0 0 1-5.188 1.686c.357.663.127 5.183.188 5.974 3.029-.35 5-1.702 5-2.91"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sushi_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSushi;
